import { logger } from '@/utils/logger';

/**
 * Production-safe logging utility
 * Only logs in development mode, silent in production
 */

const isDevelopment = import.meta.env.DEV;

export const prodLogger = {
  debug: (message: string, ...args: any[]) => {
    if (isDevelopment) {
      logger.debug(message, args.length > 0 ? args[0] : undefined);
    }
  },

  info: (message: string, ...args: any[]) => {
    if (isDevelopment) {
      logger.info(message, args.length > 0 ? args[0] : undefined);
    }
  },

  warn: (message: string, ...args: any[]) => {
    // Always log warnings
    logger.warn(message, args.length > 0 ? args[0] : undefined);
  },

  error: (message: string, error?: Error, ...args: any[]) => {
    // Always log errors
    const context = args.length > 0 ? args[0] : undefined;
    logger.error(message, error, context);
  },

  // For temporary debugging that should be removed
  temp: (message: string, ...args: any[]) => {
    if (isDevelopment) {
      logger.debug(`🚧 TEMP: ${message}`, args.length > 0 ? args[0] : undefined);
    }
  }
};

// Legacy console.log replacement
export const devLog = isDevelopment ? console.log : () => {};